// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "App/static/js/" + chunkId + "." + "7146bf9d" + ".chunk.js";
};